import { createStore, Event } from 'effector';

import { applyReducers } from '@m/effector-utils';
import { IamUser } from '@m/types/api/iam/Iam';

import { setSelectedUser } from './actions';

type State = {
  iamUserMap: {
    [key: number | string]: IamUser;
  };
};

export const initialState: State = {
  iamUserMap: {}, // only for breadcrumbs atm
};

const store = createStore(initialState);

type Reducers = {
  setSelectedUser: {
    action: Event<Parameters<typeof setSelectedUser>[0]>;
    reducer: (state: State, payload: Parameters<typeof setSelectedUser>[0]) => State;
  };
};

export const reducers: Reducers = {
  setSelectedUser: {
    action: setSelectedUser,
    reducer: (state, user) => {
      if (user?.id) {
        return {
          ...state,
          iamUserMap: {
            ...state.iamUserMap,
            [user.id]: user,
          },
        };
      }
      return state;
    },
  },
};

export default applyReducers({ storeName: 'admin/user', store, reducers });
